<div class="tag-editor-background" *ngIf="rowTagEditorOpened" (click)="rowEditorExit($event)">
  <cc-row-tags-editor *ngIf="bottom" [ngStyle]="{'left': left+'px', 'bottom': bottom +'px' }"></cc-row-tags-editor>
  <cc-row-tags-editor *ngIf="top"  [ngStyle]="{'left': left+'px', 'top': top +'px' }"></cc-row-tags-editor>
</div>
